import { makeAutoObservable } from 'mobx';

export type PreloaderFn = (show?: boolean, message?: string) => void;

class PreloaderStore {
  preloaderMessage = ' ';

  showPreloader = false;

  callStack = 0;

  constructor() {
    makeAutoObservable(this);
  }

  preloader: PreloaderFn = (show = true, message?: string): void => {
    if (show) {
      this.showPreloader = true;
      this.preloaderMessage = message || ' ';
      this.callStack++;
    } else {
      this.callStack--;
      if (this.callStack <= 0) this.showPreloader = false;
    }
  };
}

export const preloaderStore = new PreloaderStore();
